import e2e from '@/plugins/directives/e2e';

export default { directives: { e2e } };
